<template>
  <v-list class="similar-job-list pa-0 overflow-visible">
    <v-list-item
      v-for="(job, index) in jobs"
      :key="job.id"
      class="pa-4"
      :class="{ 'border-b-sm': index < jobs.length - 1 }"
      @click="emit('card-click', job)"
    >
      <Card :job="job" />
    </v-list-item>
  </v-list>
</template>

<script setup>
import Card from './Card.vue';

const emit = defineEmits(['card-click']);

const props = defineProps({
  jobs: {
    type: Array,
    required: true,
    default: () => [],
  },
});
</script>
